// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".privacy{cursor:pointer;border-style:solid;border-width:1px;border-radius:4px;border-color:#d6d6d6;padding:10px;margin-bottom:20px}.active{border-color:#007bff;border-style:solid;border-width:1px;border-radius:4px;color:#fff;background-color:#007bff}.choice{padding:10px}", ""]);
// Exports
module.exports = exports;
